import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/Icon';
import { useHelp } from '../components/HelpDialog';
import { EMERGENCY_NUMBER, SUPPORT_PHONE, SUPPORT_TEL } from '../config/site';
import { usePageMeta } from '../hooks/usePageMeta';

const NotFound: React.FC = () => {
  usePageMeta(
    'Página no encontrada · Violeta',
    'Esta página no existe o cambió de dirección. Vuelve al inicio de Violeta.',
    true,
  );
  const help = useHelp();

  return (
    <section className="nf on-dark" aria-labelledby="nf-title">
      <div className="container nf__grid">
        <div className="nf__copy">
          <p className="label">Error 404</p>
          <h1 id="nf-title">No encontramos esta página</h1>
          <p>Puede que el enlace esté incompleto o que la página haya cambiado de lugar.</p>
          <div className="nf__btns">
            <Link className="btn btn--crimson btn--lg" to="/">
              <Icon name="home" />
              Ir al inicio
            </Link>
            <Link className="btn btn--outline-light btn--lg" to="/#preguntas">
              Ver preguntas frecuentes
            </Link>
          </div>
          <div className="nf__list">
            <Link to="/descargar">
              <span>Descargar la app<small>Para Android y iPhone</small></span>
              <Icon name="download" />
            </Link>
            <a
              href="/ayuda"
              onClick={(event) => {
                event.preventDefault();
                help.open();
              }}
            >
              <span>Ayuda ahora<small>911 y líneas de Violeta</small></span>
              <Icon name="heart" />
            </a>
            <a href={SUPPORT_TEL}>
              <span>Teléfono de la app<small>{SUPPORT_PHONE} · no es de emergencias</small></span>
              <Icon name="phone" />
            </a>
            <a href={`tel:${EMERGENCY_NUMBER}`}>
              <span>¿En peligro ahora?<small>Llamar al {EMERGENCY_NUMBER}</small></span>
              <Icon name="phone" />
            </a>
          </div>
        </div>
        <div className="nf__art" aria-hidden="true">
          <span className="blob blob--big" />
          <p className="nf__digits">4<span>0</span>4</p>
          <span className="sticker">Página no encontrada</span>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
